/** @file Picks the Tree's active row: the remembered one while visible and selected, else the first selected. */
import type { TreeRow } from './flattenTree';

/** Returns the id that `aria-activedescendant` should point at, or null when no row qualifies. */
export function resolveActiveId(rows: readonly TreeRow[], activeId: string | null, selected: ReadonlySet<string>): string | null {
  const keep = activeId !== null && rows.some((r) => r.id === activeId) && (selected.size === 0 || selected.has(activeId));
  if (keep) return activeId;
  return rows.find((r) => selected.has(r.id))?.id ?? null;
}
